import React from 'react';
import { IconProps } from '../types';
const MinecraftBirchDoor: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(212, 202, 153, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(91, 62, 31, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(91, 62, 31, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(91, 62, 31, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(91, 62, 31, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(219, 219, 219, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(248, 244, 225, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(91, 62, 31, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(214, 202, 140, 255)" />
<rect x="3" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="4" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="11" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
<rect x="12" y="15" width="1" height="1" fill="rgba(153, 144, 100, 255)" />
</svg>);
export default MinecraftBirchDoor;